import {
    assocPath,
    filter,
    includes,
    map,
    mergeDeepLeft,
    omit,
    pipe,
    reduce,
    xprod
} from 'ramda';
import { parseImsDate } from 'js/hooks/useFormatter/helpers';

export const filterLimitsByAvailPeriods = periods => filter(limit => includes(limit.timePeriod, periods));

export const filterLimitsByAvailGroups = groups => filter(limit => includes(limit.products, groups));

export const generateDefaultLimits = pipe(
    xprod,
    reduce((memo, period) => assocPath(period, {
        timePeriod: period[1]
    }, memo), {})
);

export const parseCurrentLimits = map(limit => ({
    groupName: limit.products,
    timePeriod: limit.timePeriod,
    currentLimit: limit.amount.amount,
    remainingLimit: limit.remainingLimit.amount,
    currencyCode: limit.amount.currencyCode,
    resetDate: limit.resetDate
}));

export const parseWaitingLimits = map(limit => ({
    groupName: limit.products,
    timePeriod: limit.timePeriod,
    newLimit: limit.amount.amount,
    newLimitStartDate: parseImsDate(limit.startDate)
}));

export const groupLimits = reduce(
    (memo, limit) => assocPath(
        [limit.groupName, limit.timePeriod],
        omit(['groupName'], limit),
        memo
    ),
    {}
);

export default (limits, config) => {
    const { currentLimits, waitingLimits } = limits;
    const { availablePeriods, availableGroups } = config;
    const defaultLimits = generateDefaultLimits(availableGroups, availablePeriods);

    const current = pipe(
        filterLimitsByAvailPeriods(availablePeriods),
        filterLimitsByAvailGroups(availableGroups),
        parseCurrentLimits,
        groupLimits
    )(currentLimits);

    const waiting = pipe(
        filterLimitsByAvailPeriods(availablePeriods),
        filterLimitsByAvailGroups(availableGroups),
        parseWaitingLimits,
        groupLimits
    )(waitingLimits);

    return pipe(
        mergeDeepLeft(current),
        mergeDeepLeft(waiting)
    )(defaultLimits);
};

export const parseConfig = (data) => {
    const { availablePeriods, availableGroups } = data;
    const periodsMap = { 1: 'day', 2: 'week', 3: 'month' };
    const periods = availablePeriods.sort().map((period) => periodsMap[period]);
    const groups = availableGroups.filter(({ type }) => type === 'limit').map(({ products }) => products);

    return {
        ...data,
        availableGroups: groups,
        availablePeriods: periods
    };
};
